import React, { useState } from "react";
import styles from "./Form.module.css";
import activityCard from "../assets/What We Do Page Assests/1x/activity_card.png";
import privacypolicy from "../assets/pdf/JMWPrivacyPolicy.pdf"
import board from "../assets/form/Asset 3@2x.png"
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";


const API_URL = process.env.REACT_APP_API_URL || "https://server.junglemorals.com/api";


export default function FormPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    storyName: "",
    contentType: "",
    agreePrivacy: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ✅ API CONNECTED SUBMIT  
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/form/submit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // 🔥 IMPORTANT: do NOT include credentials
      credentials: "omit",
      body: JSON.stringify(formData),
    });

console.log("i am the response",res);
      
     
        toast.success("🎉 Thanks! We'll send you the fun activity cards soon!");

        // 🔹 RESET ONLY ON SUCCESS
        setFormData({
          name: "",
          email: "",
          storyName: "",
          contentType: "",
          agreePrivacy: false,
        });

    } catch (error) {
      // ❌ NETWORK / SERVER ERROR
console.log("i am the error",error);
      toast.error("⚠️ Something went wrong. Try again!",error);

      // 🔴 IMPORTANT:
      // NO setFormData here → input data remains
      console.error(error);
    }
  };


  return (
    <>
        <Helmet>
                         <title>Form | JungleMoals</title>
                         <meta name="description" content=""/>
                        <link rel="canonical" href="https://www.junglemorals.com/form" />
                    </Helmet>
      <div className={styles.formPage}>
        {/* Header */}
        <div className={styles.activityHeader}>
          <img src={activityCard} alt="" className={styles.activityCardImg} />
          <h3 className={`font-adventuring ${styles.mainh3Heading}`}>We will send you</h3>
          <h1 className={`font-adventuring ${styles.mainHeading}`}>
            Activity cards
          </h1>
        </div>
        <div className={styles.bgimg}>
          {/* Form */}
          <form className={styles.formContainer} onSubmit={handleSubmit}>
            
            {/* Name */}
            <div className={styles.formGroup}>
              <label className={`font-adventuring ${styles.label}`}>Name :</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="What shall Elephiphi and Liona call you?"
                className={styles.inputBox}
                required
              />
            </div>

            {/* Email */}
            <div className={styles.formGroup}>
              <label className={`font-adventuring ${styles.label}`}>Email :</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Where shall we send the Activity Cards?"
                className={styles.inputBox}
                required
              />
            </div>

            {/* Story Name */}
            <div className={styles.formGroup}>
              <div className={styles.radioInputWrapper}>
                <div className={`font-adventuring ${styles.radioGroup}`}>
                  Story/Interactive/Song Name:
                </div>

                <input
                  type="text"
                  name="storyName"
                  value={formData.storyName}
                  onChange={handleChange}
                  placeholder="You can leave this blank, EASY PEASY"
                  className={styles.inputBoxx}
                />

                {/* <div style={{ fontSize: '1rem', color: '#666', textAlign: 'left', marginTop: '-13px', marginLeft: '13px', fontStyle: 'italic' }}> */}
                <div className={styles.noteText}>

                  <span style={{ color: "red" }}>*</span>
                  we will send you 3 FUN at random Activity Cards.
                </div>
              </div>
            </div>

            {/* Privacy */}
            <div className={styles.privacyGroup} style={{ textAlign: "center" }}>
              <div className={`font-adventuring ${styles.privacyText}`}>
                <div className={styles.privacypolicy}>
                  By submitting this form, you agree to our {" "}
                  <a href={privacypolicy} target="_blank" rel="noopener noreferrer">
                    Privacy Policy.
                  </a>
                </div>

                {/* <div style={{ marginTop: "18px", display: "flex", alignItems: "center", gap: "6px", marginLeft: '3vw' }}>
                  <input
                    type="checkbox"
                    name="agreePrivacy"
                    checked={formData.agreePrivacy}
                    onChange={handleChange}
                    required
                    style={{ marginTop: "-18px" }}
                  />
                  <span className={styles.checkboxspan}>
                    I would love to receive weekly activities, tips,
                    <br /> and updates from Jungle Morals
                  </span>
                </div> */}


                <div className={styles.checkq}>
                  {/* <input
                    type="checkbox"
                    name="agreePrivacy"
                    checked={formData.agreePrivacy}
                    onChange={handleChange}
                    required
                    className={styles.checkboxx}
                  /> */}
                  <label className={styles.customCheckbox}>
                    <input
                      type="checkbox"
                      name="agreePrivacy"
                      checked={formData.agreePrivacy}
                      onChange={handleChange}
                      required
                    />
                    <span className={styles.checkmark}></span>

                    <span className={styles.checkboxText}>
                      I would love to receive weekly activities, tips,<br className={styles.mobilehide} />
                      and updates <br className={styles.desktophide} />from Jungle Morals
                    </span>
                  </label>
                  {/* <span className={styles.checkboxspan}>
                    I would love to receive weekly activities, tips,
                    <br /> and updates from Jungle Morals
                  </span> */}
                </div>

                <div style={{ marginTop: "10px", fontSize: "1rem" }}>
                  You can unsubscribe anytime. We respect your privacy.
                </div>
              </div>
            </div>

            {/* Submit */}
            <button type="submit" className={`font-adventuring ${styles.submitBtn}`}>
              <img src={board} alt="" />
              <h2>SEND ME THE FUN</h2>
            </button>
          </form>
        </div>


      </div>
    </>
  );
}
